import axios from 'axios/dist/axios';


const defaultState = {

    symptomsQuestionsData: [],
    footerBtnNext: {
        isEnabled: false
    },
    selectedRelatedSymptomList: [],
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    symptomsQuestionsData:     defaultState.startQuestionsData,
    footerBtnNext: {
        isEnabled:          defaultState.footerBtnNext.isEnabled
    },
    selectedRelatedSymptomList:         defaultState.selectedRelatedSymptomList,
};


// ======================================================================
// Getters
// ======================================================================

const getters = {

    getSymptomsQuestionsData: state => state.symptomsQuestionsData,

    getIsFooterNextBtnEnabled (state) {
        return (state.footerBtnNext.isEnabled) ? true : false;
    },
    getSelectedRelatedSymptomList: state => state.selectedRelatedSymptomList,

};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    loadSymptomsQuestionsData ({ commit, rootState }) {
        let promise = new Promise((resolve, reject) => {
            console.log(rootState.PfMainSymptomStore.selectedMainSymptomCode);
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/chooseMainSymptom');
            axiosRequest.then((response) => {
                console.log(response)
            console.log(response.data.data);
                commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms);

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },
    submitSymptomQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/provideAnswer', {
                answerCode: data.newProvidedAnswerCode,
                questionCode: data.questionCode
            });
            axiosRequest.then((response) => {


                if(response.data.data.SYMPTOM_LIST) {
                    // ------- Refresh symptom's SPECIFIC question list. -------
                    commit("setSymptomSpecificQuestions", {
                        questionsData: response.data.data.SYMPTOM_LIST.symptoms[0].questionsData,
                        symptomCode: response.data.data.SYMPTOM_LIST.symptoms[0].code
                    });
                }
                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                // ----- Refresh SYMPTOM question list ------
                if(typeof response.data.data.SYMPTOM_LIST !== "undefined") {
                    commit('setSelectedRelatedSymptomList', response.data.data.SYMPTOM_LIST.symptoms );
                } else if(response.data.data.SYMPTOM_LIST_PRIORITY) {
                    commit('setSelectedRelatedSymptomListPriority', response.data.data.SYMPTOM_LIST_PRIORITY.questions);
                }


                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },
    rectifySelectedSymptomList({commit, getters}) {

         let getMainSymptom = getters.getMainSymptom;
         let getRelatedSymptomList = getters.getRelatedSymptomList;
        let getSelectedRelatedSymptomList = getters.getSelectedRelatedSymptomList;

        getSelectedRelatedSymptomList.forEach((crtSelectedSymptom) => {
                let crtSelectedCode = crtSelectedSymptom.code;

                if (crtSelectedCode !== getMainSymptom.code) {
                    let relatedSymptomCorrespondingToCrtSelectedCode = getRelatedSymptomList.filter((symptom) => {
                        return (symptom.code === crtSelectedCode && symptom.state === relatedSymptomStates.HAVE_SYMPTOM);
                    });

                    if (relatedSymptomCorrespondingToCrtSelectedCode.length === 0) {
                        commit("removeSelectedSymptomFromList", crtSelectedCode);
                    }
                }
        });
    },

};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setSymptomsQuestionsData (state, newVal) {
        state.symptomsQuestionsData = newVal;
    },




    enableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = true;
    },
    disableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = false;
    },
    setSelectedRelatedSymptomList (state, value) {
        state.selectedRelatedSymptomList = value;
    },

    setSymptomSpecificQuestions (state, data) {
        // @TODO Prevent DUPLICATE IDs.
        let symptomItemIndex = state.selectedRelatedSymptomList.findIndex((symptom) => {
            return symptom.code == data.symptomCode;
        });

        if (symptomItemIndex !== -1 && typeof state.selectedRelatedSymptomList[symptomItemIndex] !== "undefined") {
            state.selectedRelatedSymptomList[symptomItemIndex].questionsData = data.questionsData;
        }
    },

    // ----------------------------------------------------------

    resetStore (state) {

        state.symptomsQuestionsData    = defaultState.symptomsQuestionsData;
        state.footerBtnNext = {
            isEnabled: defaultState.footerBtnNext.isEnabled
        };
        state.selectedRelatedSymptomList         = defaultState.selectedRelatedSymptomList;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/pathfinder/standard-forms/PfSymptomsQuestionsStore.js